import React from "react";
import { useSelector } from "react-redux";
import SamasyaV3 from "./SamasyaV3";
import CustomerOrderItemIssues from "./CustomerOrderItemIssues";

const MultiQuantityIssues = (props: any) => {
  const { partialDeliveryEnabled = false } = useSelector(
    ({ configReducer }: any) => configReducer,
  );

  if (partialDeliveryEnabled) {
    return <CustomerOrderItemIssues {...props} />;
  }
  return <SamasyaV3 {...props} />;
};

export default MultiQuantityIssues;
